const Home = () => {
    return (  
        <section id="home" class="section1">
            <div class="div1">
                <div class="content">
                <h2>Hi, welcome to WallpaperX</h2>
                <p>
                    A website where you'll find HD wallpapers both for 
                    desktops and mobile phones.
                 </p>
                <a href="#pc" class="homelink">Browse More</a>
                </div>
            </div>
        </section>
    );
}
 
export default Home;